import { render, staticRenderFns } from "./discard-confirmation.vue?vue&type=template&id=83fdc552&scoped=true"
import script from "./discard-confirmation.vue?vue&type=script&lang=js"
export * from "./discard-confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fdc552",
  null
  
)

export default component.exports